import { render, staticRenderFns } from "./complaintDetails.vue?vue&type=template&id=ba4ff7d6&scoped=true&"
import script from "./complaintDetails.vue?vue&type=script&lang=js&"
export * from "./complaintDetails.vue?vue&type=script&lang=js&"
import style0 from "./complaintDetails.vue?vue&type=style&index=0&id=ba4ff7d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba4ff7d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba4ff7d6')) {
      api.createRecord('ba4ff7d6', component.options)
    } else {
      api.reload('ba4ff7d6', component.options)
    }
    module.hot.accept("./complaintDetails.vue?vue&type=template&id=ba4ff7d6&scoped=true&", function () {
      api.rerender('ba4ff7d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/complaint/complaintDetails.vue"
export default component.exports